(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hpgc-header"]) return;
  try {
    
  (function () {
    var toggle = document.querySelector('[data-hpgc-menu-toggle]');
    var navigation = document.getElementById('hpgc-main-navigation');
    if (toggle && navigation) toggle.addEventListener('click', function () { var open = navigation.getAttribute('data-open') === 'true'; navigation.setAttribute('data-open', open ? 'false' : 'true'); toggle.setAttribute('aria-expanded', open ? 'false' : 'true'); });
    document.querySelectorAll('[data-hpgc-submenu-toggle]').forEach(function (submenuToggle) { submenuToggle.addEventListener('click', function () { var submenu = submenuToggle.closest('li').querySelector('.hpgc-header__submenu'); if (!submenu) return; var open = submenu.getAttribute('data-open') === 'true'; submenu.setAttribute('data-open', open ? 'false' : 'true'); submenuToggle.setAttribute('aria-expanded', open ? 'false' : 'true'); }); });
    var modal = document.querySelector('[data-hpgc-shipping-modal]');
    var openButton = document.querySelector('[data-hpgc-shipping-open]');

    if (!modal || !openButton) {
      return;
    }

    var closeButtons = modal.querySelectorAll('[data-hpgc-shipping-close]');
    var panel = modal.querySelector('.hpgc-header__modal-panel');

    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (panel) {
        panel.focus();
      }
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      openButton.focus();
    }

    openButton.addEventListener('click', openModal);

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hpgc-product"] && !Shopify.designMode) return;
  try {
    
  // Toggle Gift Card Recipient fields visibility
  const toggleCheckbox = document.getElementById('HpgcRecipientEmailToggle');
  if (toggleCheckbox) {
    toggleCheckbox.addEventListener('change', function() {
      const recipientFields = document.getElementById('HpgcRecipientFields');
      const emailInput = document.getElementById('HpgcRecipientEmail');
      if (this.checked) {
        recipientFields.style.display = 'grid';
        if (emailInput) emailInput.required = true;
      } else {
        recipientFields.style.display = 'none';
        if (emailInput) emailInput.required = false;
      }
    });
  }

  // Handle AJAX Add-to-Cart for single-variant complementary items.
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.js-hpgc-addon-add');
    if (!button) return;
    event.preventDefault();
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.innerText = 'Adding...';
    button.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(response => {
      if (!response.ok) throw new Error('Network error');
      return response.json();
    })
    .then(data => {
      button.innerText = 'Added!';
      button.style.backgroundColor = '#8a6f3d';
      button.style.color = '#fff';
      button.style.borderColor = '#8a6f3d';
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') cartDrawer.renderContents(data);
      else window.location.reload();
    })
    .catch(error => {
      console.error('Upsell dynamic add failed:', error);
      button.innerText = 'Error';
      button.disabled = false;
    });
  });

  function updateMainProductImage(section, imageData, sourceThumb) {
    const mainImage = section?.querySelector(".hpgc-product__main-media img");
    if (!mainImage || !imageData?.imageSrc) return;

    mainImage.src = imageData.imageSrc;
    if (imageData.imageSrcset) {
      mainImage.srcset = imageData.imageSrcset;
    }
    if (imageData.imageAlt) {
      mainImage.alt = imageData.imageAlt;
    }

    section.querySelectorAll("[data-hpgc-product-thumb]").forEach((button) => {
      const matchesMedia = imageData.mediaId && button.dataset.mediaId === imageData.mediaId;
      button.setAttribute("aria-pressed", button === sourceThumb || matchesMedia ? "true" : "false");
    });
  }

  function syncVariantUi(variantSelect) {
    const option = variantSelect.selectedOptions[0];
    const section = variantSelect.closest(".hpgc-product");
    if (!option || !section) return;
    if (option.dataset.imageSrc) updateMainProductImage(section, option.dataset);
    const price = section.querySelector("[data-hpgc-product-price]");
    if (price && option.dataset.price) {
      price.textContent = option.dataset.price;
      if (option.dataset.compareAtPrice) {
        const compareAt = document.createElement("s");
        compareAt.textContent = option.dataset.compareAtPrice;
        price.append(" ", compareAt);
      }
    }
    const submit = section.querySelector("[data-hpgc-product-submit]");
    const available = option.dataset.available !== "false";
    if (submit) { submit.disabled = !available; submit.setAttribute("aria-disabled", String(!available)); submit.textContent = available ? "Add to Cart" : "Sold Out"; }
    const url = new URL(window.location.href); url.searchParams.set("variant", option.value); window.history.replaceState({}, "", url);
  }

  document.addEventListener("click", (event) => {
    const thumb = event.target.closest("[data-hpgc-product-thumb]");
    if (!thumb) return;
    const section = thumb.closest(".hpgc-product");
    updateMainProductImage(section, thumb.dataset, thumb);
    const select = section?.querySelector("#HpgcProductVariant");
    if (select && thumb.dataset.variantId) { select.value = thumb.dataset.variantId; select.dispatchEvent(new Event("change", { bubbles: true })); }
  });

  document.addEventListener("change", (event) => {
    const variantSelect = event.target.closest("#HpgcProductVariant");
    if (variantSelect) syncVariantUi(variantSelect);
  });

  document.querySelectorAll("[data-hpgc-product-addons]").forEach(async (block) => {
    if (block.querySelector(".hpgc-addons__item")) return;
    const productId = block.dataset.productId;
    const sectionId = block.dataset.sectionId;
    if (!productId || !sectionId) return;
    try {
      const response = await fetch(`/recommendations/products?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&limit=3&intent=complementary`);
      if (!response.ok) throw new Error('Complementary recommendations failed');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const nextBlock = doc.querySelector("[data-hpgc-product-addons]");
      const nextList = nextBlock?.querySelector(".hpgc-addons__list");
      if (!nextBlock || !nextList || !nextList.children.length) {
        block.remove();
        return;
      }
      block.classList.remove("hpgc-addons--loading");
      block.innerHTML = nextBlock.innerHTML;
    } catch (error) {
      block.remove();
    }
  });

  document.querySelectorAll("[data-hpgc-product-related]").forEach(async (rail) => {
    const productId = rail.dataset.productId;
    const sectionId = rail.dataset.sectionId;
    if (!productId || !sectionId) return;

    try {
      const response = await fetch(`/recommendations/products?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&limit=4&intent=related`);
      if (!response.ok) return;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const nextRail = doc.querySelector("[data-hpgc-product-related]");
      const nextGrid = nextRail?.querySelector(".hpgc-product__related-grid");
      if (!nextGrid || !nextGrid.children.length) {
        rail.remove();
        return;
      }

      rail.classList.remove("hpgc-product__related--loading");
      rail.innerHTML = nextRail.innerHTML;
    } catch (error) {
      rail.remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
